/**
 * CompanyDashboardAddExistingKeyResultsPopup
 *
 * Dialog for picking an existing Key Result. Provides client-side search and
 * disables selection for KRs not linked to any objective. Selected item is
 * passed back via onSelectKeyResult and the dialog closes.
 */
import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { SearchInputComponent } from "../../../common/components";
import CompanyDashboardAllKeyResultsCard from "./company-dashboard-add-existing-keyresults-popup-card/company-dashboard-add-existing-keyresults-popup-card";
import { getProgressColor } from "../company-dashboard-utils";
import dayjs from "dayjs";
import CloseIcon from "../../../assets/icons/closeIcon.svg";
import "./company-dashboard-add-existing-keyresults-popup.scss";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const CompanyDashboardAddExistingKeyResultsPopup: any = (props: any) => {
  const {
    isOpenAddPopup,
    onCancel,
    selectedKeyResultsData, // <-- already filtered available key results
    onSelectKeyResult, // callback to parent
  } = props;
  const [sortedKeyResultsData, setSortedKeyResultsData] = useState<any[]>([]);
  useEffect(() => {
    setSortedKeyResultsData(selectedKeyResultsData);
  }, [selectedKeyResultsData]);
  const handleSearch = (value: string) => {
    if (!value) {
      setSortedKeyResultsData(selectedKeyResultsData);
      return;
    }

    const filteredResults = selectedKeyResultsData.filter((kr: any) =>
      kr.keyResultTitle.toLowerCase().includes(value.toLowerCase()),
    );
    setSortedKeyResultsData(filteredResults);
  };
  return (
    <Dialog
      open={isOpenAddPopup}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        onCancel();
      }}
      className="company-dashboard-add-existing-objectives-popup-container"
    >
      <DialogTitle>
        <div className="header-wrapper">
          <div className="header-wrapper-text">Add Existing KeyResults</div>
          <div className="image-wrapper">
            <button
              style={{
                background: "transparent",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
              onClick={onCancel}
            >
              <img
                alt="Close"
                style={{ cursor: "pointer" }}
                src={CloseIcon}
                className="close-icon"
              />
            </button>
          </div>
        </div>
      </DialogTitle>

      <DialogContent>
        <OverlayScrollbarsComponent
          style={{ maxHeight: "500px" }}
          options={{
            scrollbars: {
              theme: "os-theme-dark",
              autoHide: "scroll",
              autoHideDelay: 400,
            },
          }}
        >
          {sortedKeyResultsData?.length > 0 && (
            <div className="company-dashboard-add-existing-objectives-popup-container-search">
              <SearchInputComponent
                placeholder="Search Key Results"
                onSearch={handleSearch}
                isReset={false}
                ref={null}
              />
            </div>
          )}
          {sortedKeyResultsData?.length > 0 ? (
            sortedKeyResultsData.map((item: any) => {
              const hasNoObjectives =
                !item.objectiveId ||
                (Array.isArray(item.objectiveId) &&
                  item.objectiveId.length === 0);
              return (
                <CompanyDashboardAllKeyResultsCard
                  key={item.keyResultId}
                  onClick={() => {
                    if (hasNoObjectives) return; // Prevent click if no objectives
                    onSelectKeyResult(item); // send selected KR back to parent
                    onCancel();
                  }}
                  mainLabel={item.keyResultTitle}
                  progressValue={item.progress || 0}
                  subLabel={`Last Updated ${item.lastUpdated ? dayjs(item.lastUpdated).format("MM-DD-YYYY") : "-"}`}
                  objectivesCount={item.objectiveCount || 0}
                  initiativesCount={item.initiativeCount || 0}
                  borderColor={getProgressColor(item.status).mainColor}
                  lightBorderColor={getProgressColor(item.status).lightColor}
                  style={{
                    opacity: hasNoObjectives ? 0.5 : 1,
                    cursor: hasNoObjectives ? "not-allowed" : "pointer",
                  }}
                />
              );
            })
          ) : (
            <div className="company-dashboard-no-objective">No Key Results</div>
          )}
        </OverlayScrollbarsComponent>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyDashboardAddExistingKeyResultsPopup;
